import React from 'react';
import { Route, Link, BrowserRouter as Router } from "react-router-dom"
import Rank from './Rank'
import Image from 'react-image-resizer';
import {App, uFirstName, uLastName, uRating, uId, uIsSignedIn, uRatingCount,uImageKey,uAdministrator} from '../containers/App'
import ProfileNavigation from '../components/Navigation/profileNavigation';
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import Card from 'react-bootstrap/Card'
import Badge from 'react-bootstrap/Badge'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { FaUsers, FaUserEdit, FaSignOutAlt, FaStar, FaTrophy, FaChartLine } from "react-icons/fa";
import { getSecureItem } from '../utils/encryption';
import env from "react-dotenv";

let url = "https://p10-profile-image.s3.amazonaws.com"

class Profile extends React.Component {
  componentDidMount() {
    // Load from encrypted localStorage if no props
    try {
      const savedState = getSecureItem('p10-app-state');
      
      if (savedState) {
        if (savedState.user && savedState.user.id) {
          // Update global variables with saved data
          window.uFirstName = savedState.user.first_name;
          window.uLastName = savedState.user.last_name;
          window.uRating = savedState.user.rating;
          window.uId = savedState.user.id;
          window.uRatingCount = savedState.user.rating_count;
          window.uImageKey = savedState.user.image_key;
          window.uAdministrator = savedState.user.administrator;
          window.uGender = savedState.user.gender;
          window.uEmail = savedState.user.email;
          window.uJoined = savedState.user.joined;
          window.uProfileImage = savedState.user.profile_image;
          window.uIsSignedIn = true;
          
          console.log('Profile: User data loaded from encrypted storage');
          
          // Force re-render with updated data
          this.forceUpdate();
        }
      }
    } catch (error) {
      console.error('Error loading state:', error);
    }
  }

  componentDidUpdate(prevProps) {
	  // Reload from encrypted storage when component updates
	  try {
	    const savedState = getSecureItem('p10-app-state');
	    if (savedState && savedState.user) {
	      const currentImageKey = window.uImageKey || uImageKey;
	      const newImageKey = savedState.user.image_key;
	      
	      // If image key changed, update and re-render
	      if (newImageKey && newImageKey !== currentImageKey) {
	        window.uImageKey = newImageKey;
	        this.forceUpdate();
	      }
	    }
	  } catch (error) {
	    console.error('Error checking for updates:', error);
	  }
	}

  constructor(props) {
    super(props);
    
    // Try to get user from props first, then encrypted localStorage
    let user = this.props.user;
    
    if (!user || !user.id) {
      try {
        const savedState = getSecureItem('p10-app-state');
        if (savedState) {
          user = savedState.user;
        }
      } catch (error) {
        console.error('Error loading user from storage:', error);
      }
    }
    
    this.state = {
      user: user || null
    };
  }

  getRatingColor = (rating) => {
    if (rating >= 9) return '#10b981'; // Green
    if (rating >= 7) return '#3b82f6'; // Blue
    if (rating >= 5) return '#f59e0b'; // Orange
    return '#ef4444'; // Red
  }

  getRatingLevel = (rating) => {
    if (rating >= 9.5) return 'Perfect 10!';
    if (rating >= 9) return 'Excellent';
    if (rating >= 7) return 'Great';
    if (rating >= 5) return 'Good';
    return 'Getting Started';
  }

  render() {
    // Get values from window (updated in componentDidMount) or fall back to imports
    let userRating = window.uRating || uRating;
    let userRatingCount = window.uRatingCount || uRatingCount;
    let userImageKey = window.uImageKey || uImageKey;
    let userAdmin = window.uAdministrator || uAdministrator;
    let firstName = window.uFirstName || uFirstName;
    let lastName = window.uLastName || uLastName;
    
    if(userRating == null) userRating = 0;
    if(userRatingCount == null) userRatingCount = 0;
    
    const ratingNum = parseFloat(userRating);
    const imageURL = `${url}/${userImageKey}?t=${Date.now()}`;
    const ratingColor = this.getRatingColor(ratingNum);
    const ratingLevel = this.getRatingLevel(ratingNum);

    return (
      <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
        {/* Modern Top Navigation */}
        <Navbar expand="lg" fixed="top" bg="white" variant="light" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <Container>
            <Navbar.Brand>
              <img src="/images/p10.jpg" alt="P10" style={{ height: '40px', marginRight: '10px',borderRadius: '8px' }}/>
              <span style={{ fontWeight: '600', fontSize: '1.2rem', color: '#1f2937' }}>P10 Rating</span>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="main-navbar" />
            <Navbar.Collapse id="main-navbar">
              <Nav className="ms-auto">
                {userAdmin === 1 ? (
                  <>
                    <Link to={'/Main'} className="nav-link"><FaUsers /> Profiles</Link>
                    <Link to={'/Dimes'} className="nav-link"><FaUsers /> Dimes</Link>
                    <Link to={'/UserDimes'} className="nav-link"><FaUsers /> My Dimes</Link>
                    <Link to={'/AddDime'} className="nav-link"><FaUsers /> Add Dimes</Link>
                    <Link to={'/EditProfile'} className="nav-link"><FaUserEdit /> Edit</Link>
                    <Link to={'/Reported'} className="nav-link"><FaUsers /> Reports</Link>
                    <Link to={'/ReportedDime'} className="nav-link"><FaUsers /> Dime Reports</Link>
                    <Link to={'/Signin'} className="nav-link text-danger"><FaSignOutAlt /> Logout</Link>
                  </>
                ) : (
                  <>
                    <Link to={'/Main'} className="nav-link"><FaUsers /> Profiles</Link>
                    <Link to={'/Dimes'} className="nav-link"><FaUsers /> Dimes</Link>
                    <Link to={'/UserDimes'} className="nav-link"><FaUsers /> My Dimes</Link>
                    <Link to={'/AddDime'} className="nav-link"><FaUsers /> Add Dimes</Link>
                    <Link to={'/EditProfile'} className="nav-link"><FaUserEdit /> Edit</Link>
                    <Link to={'/signin'} className="nav-link text-danger"><FaSignOutAlt /> Logout</Link>
                  </>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Main Content */}
        <Container style={{ paddingTop: '100px', paddingBottom: '100px' }}>
          
          {/* Hero Section */}
          <Row className="mb-4">
            <Col>
              <div style={{ 
                background: 'linear-gradient(135deg, #127EE0 0%, #0a5fb3 100%)',
                borderRadius: '16px',
                padding: '40px',
                color: 'white',
                textAlign: 'center',
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
              }}>
                <h1 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px' }}>
                  Be Perfect!
                </h1>
                <p style={{ fontSize: '1.2rem', opacity: 0.9 }}>
                  Your rating, your progress, your perfect
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            {/* Left Column - Profile Card */}
            <Col lg={4} className="mb-4">
              <Card style={{ 
                borderRadius: '16px', 
                border: 'none',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                overflow: 'hidden'
              }}>
                <div style={{ 
                  background: 'linear-gradient(135deg, #127EE0 0%, #0a5fb3 100%)',
                  padding: '30px',
                  textAlign: 'center'
                }}>
                  <div style={{
                    width: '150px',
                    height: '150px',
                    margin: '0 auto',
                    borderRadius: '50%',
                    border: '5px solid white',
                    overflow: 'hidden',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f3f4f6'
                  }}>
                    <img 
                      src={imageURL} 
                      alt={firstName}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center'
                      }}
                    />
                  </div>
                  
                  <h2 style={{ 
                    color: 'white', 
                    marginTop: '20px',
                    fontSize: '1.8rem',
                    fontWeight: '600'
                  }}>
                    {firstName} {lastName}
                  </h2>
                  
                  {userAdmin === 1 && (
                    <Badge bg="warning" style={{ fontSize: '0.9rem', padding: '6px 12px' }}>
                      Administrator
                    </Badge>
                  )}
                </div>
                
                <Card.Body style={{ padding: '30px' }}>
                  <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  </div>
                  
                  <Link to="/EditProfile">
                    <button style={{
                      width: '100%',
                      padding: '12px',
                      backgroundColor: '#3b82f6',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '1rem',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.3s'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                    >
                      <FaUserEdit /> Edit Profile
                    </button>
                  </Link>
                </Card.Body>
              </Card>
            </Col>

            {/* Right Column - Stats */}
            <Col lg={8}>
              <Row className="mb-4">
                {/* Rating Card */}
                <Col md={6} className="mb-4">
                  <Card style={{ 
                    borderRadius: '16px',
                    border: 'none',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    height: '100%'
                  }}>
                    <Card.Body style={{ padding: '30px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                        <FaStar style={{ color: '#f59e0b', fontSize: '1.5rem', marginRight: '10px' }} />
                        <h5 style={{ margin: 0, color: '#6b7280' }}>Current Rating</h5>
                      </div>
                      <div style={{ 
                        fontSize: '3rem', 
                        fontWeight: '700',
                        color: ratingColor,
                        marginBottom: '10px'
                      }}>
                        {ratingNum.toFixed(1)}
                      </div>
                      <Badge 
                        bg="light" 
                        text="dark"
                        style={{ 
                          fontSize: '0.9rem', 
                          padding: '6px 12px',
                          backgroundColor: ratingColor + '20',
                          color: ratingColor
                        }}
                      >
                        Your p10 Rating {ratingLevel}
                      </Badge>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Total Ratings Card */}
                <Col md={6} className="mb-4">
                  <Card style={{ 
                    borderRadius: '16px',
                    border: 'none',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    height: '100%'
                  }}>
                    <Card.Body style={{ padding: '30px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                        <FaChartLine style={{ color: '#3b82f6', fontSize: '1.5rem', marginRight: '10px' }} />
                        <h5 style={{ margin: 0, color: '#6b7280' }}>Total Ratings</h5>
                      </div>
                      <div style={{ 
                        fontSize: '3rem', 
                        fontWeight: '700',
                        color: '#1f2937',
                        marginBottom: '10px'
                      }}>
                        {userRatingCount}
                      </div>
                      <div style={{ fontSize: '0.9rem', color: '#6b7280' }}>
                        {userRatingCount === 0 ? 'Get your first rating!' : 'Reviews received'}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* Quick Actions */}
              <Card style={{ 
                borderRadius: '16px',
                border: 'none',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                <Card.Body style={{ padding: '30px' }}>
                  <h5 style={{ marginBottom: '20px' }}>Quick Actions</h5>
                  <Row>
                    <Col md={4} className="mb-3">
                      <Link to="/Main" style={{ textDecoration: 'none' }}>
                        <div style={{
                          textAlign: 'center',
                          padding: '20px',
                          backgroundColor: '#f3f4f6',
                          borderRadius: '12px',
                          cursor: 'pointer',
                          transition: 'all 0.3s'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e5e7eb'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                        >
                          <FaUsers style={{ fontSize: '2rem', color: '#3b82f6', marginBottom: '10px' }} />
                          <div style={{ fontWeight: '600', color: '#1f2937' }}>Browse Profiles</div>
                        </div>
                      </Link>
                    </Col>
                    <Col md={4} className="mb-3">
                      <Link to="/Dimes" style={{ textDecoration: 'none' }}>
                        <div style={{
                          textAlign: 'center',
                          padding: '20px',
                          backgroundColor: '#f3f4f6',
                          borderRadius: '12px',
                          cursor: 'pointer',
                          transition: 'all 0.3s'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e5e7eb'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                        >
                          <FaStar style={{ fontSize: '2rem', color: '#f59e0b', marginBottom: '10px' }} />
                          <div style={{ fontWeight: '600', color: '#1f2937' }}>View Dimes</div>
                        </div>
                      </Link>
                    </Col>
                    <Col md={4} className="mb-3">
                      <Link to="/UserDimes" style={{ textDecoration: 'none' }}>
                        <div style={{
                          textAlign: 'center',
                          padding: '20px',
                          backgroundColor: '#f3f4f6',
                          borderRadius: '12px',
                          cursor: 'pointer',
                          transition: 'all 0.3s'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e5e7eb'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                        >
                          <FaTrophy style={{ fontSize: '2rem', color: '#10b981', marginBottom: '10px' }} />
                          <div style={{ fontWeight: '600', color: '#1f2937' }}>My Dimes</div>
                        </div>
                      </Link>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Modern Footer */}
        <div style={{ 
          backgroundColor: 'white',
          borderTop: '1px solid #e5e7eb',
          padding: '20px 0',
          position: 'fixed',
          bottom: 0,
          width: '100%',
          boxShadow: '0 -2px 4px rgba(0,0,0,0.05)'
        }}>
          <Container>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '20px',
              fontSize: '0.9rem'
            }}>
              <span style={{ color: '#6b7280' }}>© 2026 p10rating</span>
              <Link to="/privacypolicy" style={{ color: '#3b82f6', textDecoration: 'none' }}>Privacy</Link>
              <Link to="/disclaimer" style={{ color: '#3b82f6', textDecoration: 'none' }}>Disclaimer</Link>
              <Link to="/terms" style={{ color: '#3b82f6', textDecoration: 'none' }}>Terms</Link>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}

export default Profile;